const XML_ESCAPE_MAP: Record<string, string> = {
    '"': '&quot;',
    '&': '&amp;',
    "'": '&apos;',
    '<': '&lt;',
    '>': '&gt;'
};

const XML_ESCAPE_PATTERN = /[&<>"']/g;

const escapeXml = (value: string): string =>
    value.replace(XML_ESCAPE_PATTERN, character => XML_ESCAPE_MAP[character]);

export default escapeXml;
